import { OktonLoadingState } from '@okton/platform-ui';
import React, { useEffect } from 'react';

const SsoLogout: React.FC = () => {
  useEffect(() => {
    const executar = () => {
      const params = new URLSearchParams(window.location.search);

      const continueUrl = params.get('continue');

      if (!continueUrl) {
        window.location.replace('/login');
        return;
      }

      let url: URL;

      try {
        url = new URL(continueUrl);
      } catch {
        window.location.replace('/login');
        return;
      }

      const code = url.searchParams.get('code');

      const valido =
        url.protocol === 'https:' &&
        url.hostname === 'sso.okton.com.br' &&
        url.port === '' &&
        url.pathname === '/logout/continue' &&
        url.hash === '' &&
        !!code &&
        code.length >= 16 &&
        code.length <= 512;

      if (!valido) {
        window.location.replace('/login');
        return;
      }

      /*
       * Tokens usados pelas diferentes versões
       * do frontend/backend do Integra.
       */
      [
        '@DS850:token',
        'meu:token',
        'token',

        '@DS850:refreshToken',
        'meu:refreshToken',
        'refreshToken',

        '@DS850:user',
        'user',

        '@DS850:permissoes',
        'permissoes',
      ].forEach(key => {
        localStorage.removeItem(key);
      });

      sessionStorage.removeItem('okton_sso_skip_once');

      sessionStorage.removeItem('okton_sso_state');

      localStorage.setItem('okton_global_logout', String(Date.now()));

      window.location.replace(continueUrl);
    };

    executar();
  }, []);

  return <OktonLoadingState title="Encerrando sessão..." minH="100vh" />;
};

export default SsoLogout;
